angular.module("app").controller("AddPopupPageController", [
    '$scope',
    'popupsService',
    'pageStatuses',
    'errorHandler',
    'logger',
    'userStorage',
    'settingsService',
    'preloadedNames',
    function ($scope, popupsService, pageStatuses,  errorHandler, logger, userStorage, settingsService, preloadedNames) {
        var init;

        $scope.actualPageNames = angular.copy(preloadedNames);
        $scope.userData = userStorage.getUserData();
        $scope.settings = settingsService.getSettings();
        $scope.pageStatuses = pageStatuses;
        $scope.tooltip = {
            pageTitle: "",
            expiry_time: ""
        };

        (init = function () {
            $scope.pageData = {
                title: "",
                name: preloadedNames[0] ? preloadedNames[0].name : "",
                status: $scope.pageStatuses[0],
                login: 2,
                setToAllLangs: true
            };
            $scope.vm = {
                dateTimeFrom: ""
            };
/*            $scope.imageToLoad = undefined;
            $scope.draggedImage = "";
            $scope.draggedImageDataUrl = "";*/
        })();

        $scope.submitAddPageForm = function () {
            delete $scope.pageData.forceTOChange;
            var requestObj = {
                popup: angular.copy($scope.pageData)
            };

            !!$scope.vm.fromDate && (requestObj.popup.start_date = $scope.vm.fromDate);

            popupsService.create(requestObj).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.saved");
                        init();
                        $scope.add_page_form && $scope.add_page_form.$setPristine && $scope.add_page_form.$setPristine();
                        $scope.$emit("force:reset:editor");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (error) {
                    errorHandler(error.message);
                }
            )
        };

        $scope.handleChangeOfSetToAllLanguagesBox = function (isEnabled) {
            if (isEnabled) {
                delete $scope.pageData.lang
            } else {
                $scope.pageData.lang = $scope.settings.skin.defaultLang || $scope.settings.skin.languages[0];
            }
        };

/*
        cropperService.call($scope);
*/

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            $scope.vm.dateTimeFrom = dateTime;
            $scope.vm.fromDate = dateToSave;
            $scope.pageData.start_date = $scope.vm.fromDate;
        };
    }
]);